import {Box, Typography} from "@mui/material";

export default function NotFoundPage(){
    return(
        <Box height='100dvh' display='flex' alignItems='center' justifyContent='center'>
            <Typography sx={{fontSize: '30px'}}>صفحه یافت نشد.</Typography>
        </Box>
    )
}
